import { render, staticRenderFns } from "./saveAttentionAlert.vue?vue&type=template&id=46081e2f&"
import script from "./saveAttentionAlert.vue?vue&type=script&lang=ts&"
export * from "./saveAttentionAlert.vue?vue&type=script&lang=ts&"
import style0 from "./saveAttentionAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports